import { number, string } from 'yup'
import { regexps }        from '../../../utils'
import { i18nErrorCodes } from '../form-utils'

const {
  min1,
  invalidPhoneFormat,
  invalidEmail,
  invalidCifFormat,
  invalidDniFormat,
  hasToBeAnInteger,
  invalidPasswordFormat
} = i18nErrorCodes

export const min1Schema = string().min(1, min1)

export const phoneSchema = string().matches(regexps.phone, invalidPhoneFormat)

export const passwordSchema = string().matches(regexps.password, invalidPasswordFormat)

export const emailSchema = string().email(invalidEmail)

export const cifSchema = string().matches(regexps.cif, invalidCifFormat)

export const dniSchema = string().matches(regexps.dni, invalidDniFormat)

export const integerMin1 = number().integer(hasToBeAnInteger).min(1, min1)



// WEBPACK FOOTER //
// ./src/components/forms/schemas/formatSchemas.ts